import React, { Component } from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'

import Button from './UI/Button'
import NumberInput from './UI/NumberInput'
import NumberInput2 from  './UI/NumberInput2'
import Toggle from './UI/Toggle'

import { isActive } from '../utilities'

import tooltips from '../constants/tooltips.json'

import {
  setButtonPresetMode,
  selectButton,
  setButtonChannel,
  setButtonProgramChange,
  setButtonNote,
  setButtonBankSelect,
  setButtonCC
} from '../actions/'

class ButtonsFadersButtons extends Component {
  render() {
    const {
      presetButtonsMode,
      buttons,
      selectedButton,
      onSelectButton,
      onSetButtonPresetMode,
      onSelectButtonChannel,
      onSelectButtonProgramChange,
      onSelectButtonBankSelect,
      onSelectButtonNote,
      onSelectButtonCC,
      showTooltips
    } = this.props

    const currentButton = buttons[selectedButton]
    const currentButtonMode = presetButtonsMode[selectedButton]

    return (
      <div className="buttons-faders-buttons">
        <div
          className={classnames('button-group round')}
          data-tip={tooltips['editor-button-select']}
          data-multiline="true"
          data-place="bottom"
          data-tip-disable={!showTooltips}
          >
          <Button kind="round" index={0} value={0} toggle={selectedButton} onClick={onSelectButton} />
          <Button kind="round" index={1} value={1} toggle={selectedButton} onClick={onSelectButton} />
          <Button kind="round" index={2} value={2} toggle={selectedButton} onClick={onSelectButton} />
          <Button kind="round" index={3} value={3} toggle={selectedButton} onClick={onSelectButton} />
        </div>
        <div className="button-grid">
          <div
            className={classnames('label preset-select', {active: !!currentButtonMode})}
            data-tip={tooltips['editor-button-preset-select-mode']}
            data-multiline="true"
            data-place="bottom"
            data-tip-disable={!showTooltips}
            >
            Preset Select Mode
          </div>
          <div
            className={classnames('button-preset-mode-toggle', {active: !!currentButtonMode})}>
              <Toggle
                checked={!!presetButtonsMode[selectedButton]}
                onChange={(event) => onSetButtonPresetMode(presetButtonsMode, selectedButton, ~~event.target.checked)}
              />
            </div>

          <div
            className="label button-channel"
            data-tip={tooltips['editor-button-channel']}
            data-multiline="true"
            data-place="bottom"
            data-tip-disable={!showTooltips}
            >Channel</div>
          <NumberInput
            name="channel"
            min={1} max={16}
            value={currentButton.channel + 1}
            onChange={(value) => onSelectButtonChannel(selectedButton, value)}
          />

          <div
            className={classnames('label', 'button-program-change', {'active': isActive(currentButton.patch)})}
            data-tip={tooltips['editor-button-program-change']}
            data-multiline="true"
            data-place="bottom"
            data-tip-disable={!showTooltips}
            >Program Change</div>
          <NumberInput2
            name="prgm-change"
            min={-1} max={127}
            value={currentButton.patch}
            onChange={(value) => onSelectButtonProgramChange(selectedButton, value)}
          />

          <div
            className={classnames('label', 'button-note', {'active': isActive(currentButton.note)})}
            data-tip={tooltips['editor-button-note']}
            data-multiline="true"
            data-place="bottom"
            data-tip-disable={!showTooltips}
            >Note #</div>
          <NumberInput2
            name="note"
            min={-1} max={127}
            value={currentButton.note}
            onChange={(value) => onSelectButtonNote(selectedButton, value)}
          />
          <div className='bank-select-group'>
            <div
              className={
                classnames(
                  'label',
                  'button-bank-select',
                  {'active': isActive(currentButton.bankMSB) || isActive(currentButton.bankLSB)}
                )
              }
              data-tip={tooltips['editor-button-bank-select']}
              data-multiline="true"
              data-place="bottom"
              data-tip-disable={!showTooltips}
              >
              Bank Select
            </div>
            <NumberInput2
              name="bank-select-msb"
              min={-1} max={127}
              value={currentButton.bankMSB}
              onChange={(value) => onSelectButtonBankSelect(selectedButton, value, currentButton.bankLSB)}
            />
            <NumberInput2
              name="bank-select-lsb"
              min={-1} max={127}
              value={currentButton.bankLSB}
              onChange={(value) => onSelectButtonBankSelect(selectedButton, currentButton.bankMSB, value)}
            />
          </div>


          <div
            className={classnames('label', 'button-cc', {'active': isActive(currentButton.cc)})}
            data-tip={tooltips['editor-button-cc']}
            data-multiline="true"
            data-place="bottom"
            data-tip-disable={!showTooltips}
            >CC</div>
          <NumberInput2
            name="cc"
            min={-1} max={127}
            value={currentButton.cc}
            onChange={(value) => onSelectButtonCC(selectedButton, value)}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    presetButtonsMode: state.device.presetButtonsMode,
    selectedButton: state.editor.selectedButton,
    buttons: state.currentPreset.buttons,
    showTooltips: state.editorPreferences.showTooltips
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSetButtonPresetMode: (modes, index, mode) => {
      dispatch(setButtonPresetMode(modes, index, mode))
    },
    onSelectButton: (target) => {
      dispatch(selectButton(~~target.value))
    },
    onSelectButtonChannel: (index, value) => {
      dispatch(setButtonChannel(index, ~~value - 1))
    },
    onSelectButtonProgramChange: (index, value) => {
      dispatch(setButtonProgramChange(index, ~~value))
    },
    onSelectButtonBankSelect: (index, msb, lsb) => {
      dispatch(setButtonBankSelect(index, msb, lsb))
    },
    onSelectButtonNote: (index, value) => {
      dispatch(setButtonNote(index, ~~value))
    },
    onSelectButtonCC: (index, value) => {
      dispatch(setButtonCC(index, ~~value))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ButtonsFadersButtons)
